import { ENV } from '../configurations/api/url';

/**
 * Marketing site origin for legal/footer links.
 * Production → https://thspian.com
 * Non-production (dev / qa / local) → https://dev.thspian.com
 */
export function getMarketingSiteBaseUrl(): string {
    if (ENV.ENVIRONMENT === 'production') {
        return 'https://thspian.com';
    }
    return 'https://dev.thspian.com';
}

export function marketingTermsOfServiceUrl(): string {
    return `${getMarketingSiteBaseUrl()}/terms-of-service`;
}

export function marketingPrivacyPolicyUrl(): string {
    return `${getMarketingSiteBaseUrl()}/privacy-policy`;
}

/** Circuul / App Install documentation on the marketing site. */
export function marketingAppInstallDocsUrl(path = '/docs/app-install'): string {
    const normalized = path.startsWith('/') ? path : `/${path}`;
    return `${getMarketingSiteBaseUrl()}${normalized}`;
}
